import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import { useMemo } from 'react';
import { OBJECT_LIST_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { GET_LIST_FORM_CREATOR_QUERY } from '../data/queries';
import { NewPropertiesForm } from 'customer-data-properties/form/NewPropertiesForm';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const alwaysUndefined = () => undefined;
const FormContainer = styled.div.attrs({
  'data-test-id': 'custom-properties-container'
}).withConfig({
  displayName: "CustomPropertiesForm__FormContainer"
})(["max-width:450px;width:100%;"]);
export default function CustomPropertiesForm({
  onChange,
  onStatusChange,
  values
}) {
  const {
    loading,
    data,
    error
  } = useQuery(GET_LIST_FORM_CREATOR_QUERY, {
    variables: {
      objectTypeId: OBJECT_LIST_TYPE_ID
    }
  });
  const properties = useMemo(() => {
    if (loading || error || !data) {
      return null;
    }
    const validProperties = data.objectCreatorFields.filter(property => property.identifier !== 'hs_list_name' && property.identifier !== 'hs_processing_type' && property.identifier !== 'hs_object_type_id');
    return validProperties.map(objectCreatorField => ({
      propertyName: objectCreatorField.identifier,
      isRequired: objectCreatorField.required
    }));
  }, [loading, error, data]);
  if (loading) {
    return /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {})
    });
  }

  /**
   * Do not render custom properties form when it contains:
   * hs_list_name, hs_processing_type, or hs_object_type_id -> these properties already exist in the form.
   */
  if (!properties || properties.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormContainer, {
    children: /*#__PURE__*/_jsx(NewPropertiesForm, {
      getSavedValue: alwaysUndefined,
      inputMode: "create",
      objectTypeId: OBJECT_LIST_TYPE_ID,
      onChange: onChange,
      onStatusChange: onStatusChange,
      properties: properties,
      values: values
    })
  });
}